import service from '@/services/superaccess'

const department = {
  state: {
    department_modal: false
  },
  mutations: {
    updateStatusDepartmentModal (state, status) {
      state.department_modal = status
    }
  },
  getters: {
    getStatusDepartmentModal (context) {
      return context.department_modal
    }
  },
  actions: {
    saveDepartment (context, payload) {
      return service.post('/api/department/create', context, { department: payload })
    },
    updateDepartment (context, payload) {
      return service.patch('/api/department/modify', context, { department: payload })
    },
    changeDepartmentStatus (context, payload) {
      return service.patch('/api/department/inactive', context, payload)
    },
    setStatusDepartmentModal (context, payload) {
      context.commit('updateStatusDepartmentModal', payload)
    },
    retrieveDepartment (context, payload) {
      return service.post('/api/department/list', context)
    }
  }
}

export default department



// WEBPACK FOOTER //
// app/javascript/src/store/department.js